export type AppEnv = 'development' | 'test' | 'production';
export type ClientType = 'app' | 'h5' | 'pc';
export type CryptoMode = 'none' | 'sign_only' | 'encrypt_and_sign';

export interface ClientEnv {
  allowSessionStorage: boolean;
  apiBaseUrl: string;
  appEnv: AppEnv;
  appName: string;
  appVersion: string;
  buildVersion: string;
  clientType: ClientType;
  cryptoKeyId: string;
  cryptoMode: CryptoMode;
  cryptoTestSecret: string;
  defaultLanguage: string;
  enableDebug: boolean;
  /** Google Identity Services Web Client ID；空则 Google 登录不可用。 */
  googleClientId: string;
  siteId: string;
  /** 可选：显式皮肤 code（如 gc987-h5）；空则按 siteId 映射。 */
  skinCode: string;
}

const readBool = (value: string | undefined, fallback: boolean) => {
  if (value === undefined || value === '') return fallback;
  return value === 'true';
};

const readAppEnv = (value: string | undefined): AppEnv => {
  if (value === 'test' || value === 'production') return value;
  return 'development';
};

const readClientType = (value: string | undefined): ClientType => {
  if (value === 'h5' || value === 'pc') return value;
  return 'app';
};

const readCryptoMode = (value: string | undefined): CryptoMode => {
  if (value === 'sign_only' || value === 'encrypt_and_sign') return value;
  return 'none';
};

export const clientEnv: ClientEnv = {
  allowSessionStorage: readBool(import.meta.env.VITE_ALLOW_SESSION_STORAGE, false),
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  appEnv: readAppEnv(import.meta.env.VITE_APP_ENV),
  appName: import.meta.env.VITE_APP_NAME || 'Estelar Player App',
  appVersion: import.meta.env.VITE_APP_VERSION || '0.1.0',
  buildVersion: import.meta.env.VITE_BUILD_VERSION || 'local',
  clientType: readClientType(import.meta.env.VITE_CLIENT_TYPE),
  cryptoKeyId: import.meta.env.VITE_CRYPTO_KEY_ID || '',
  cryptoMode: readCryptoMode(import.meta.env.VITE_CRYPTO_MODE),
  cryptoTestSecret: import.meta.env.VITE_CRYPTO_TEST_SECRET || '',
  defaultLanguage: import.meta.env.VITE_DEFAULT_LANGUAGE || 'pt-BR',
  enableDebug: readBool(import.meta.env.VITE_ENABLE_DEBUG, false),
  googleClientId: (import.meta.env.VITE_GOOGLE_CLIENT_ID || '').trim(),
  siteId: import.meta.env.VITE_SITE_ID || 'verdebet-br-web',
  skinCode: (import.meta.env.VITE_SKIN_CODE || '').trim(),
};
